import { connect } from 'react-redux'
import Enums from '../../utils/enums'
import { columnTemplates } from '../../utils/templates'
import { fetchAllData, addTab, deleteProfile } from '../../core/core-actions'
import { createProfile, editProfile } from '../../core/core-utils'
import ListViewTree from '../components/list-view-tree'

const mapStateToProps = (state) => {
  if (!state[state.core.tabObject.activeApp]) {
    return {}
  }

  const appId = state.core.tabObject.activeApp

  return {
    appId,
    state: state[appId],
    theme: state.core.theme,
    viewTitle: Enums.APP_VIEW_TITLES[appId],
    viewColumns: columnTemplates[appId],
    searchFilter: state[appId].searchFilter
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllData: (appId, callback) => {
      dispatch(fetchAllData(appId, callback))
    },
    addTab: (payload) => {
      dispatch(addTab(payload))
    },
    createProfile: (appId, callback) => {
      createProfile(appId, callback)
    },
    editProfile: (appId, recordId, viewData, callback) => {
      // Deep copy viewData to prevent changes to the original object
      // It will cause an immutable state error
      editProfile(appId, recordId, JSON.parse(JSON.stringify(viewData)), callback)
    },
    deleteProfile: (appId, activeKey, state, callback) => {
      dispatch(deleteProfile(appId, activeKey, state, callback))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListViewTree)
